/* eslint-disable @nx/enforce-module-boundaries */
// Do not edit this file, it is auto-generated at build time!
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';

import { EditableHTLWrapper, LinkBanner } from '@marriott/mi-common-static-components';

import {
  AvailabilityCalendarEditable,
  HotelGalleryTitleEditable,
  MapAndRegionCardEditable,
  ExploreDestinationsEditable,
  SearchFormEditable,
  MeetingsAndEventsSearchFormEditable,
  MerchBannerEditable,
} from '@marriott/mi-shop-components';

import { HotelInformationComponentEditable } from '@marriott/mi-shop-components';
import { HeadingComponent } from '@marriott/mi-shop-components';

import { HvmiBannerEditable } from '@marriott/mi-shop-components';
import { HotelOverviewComponentEditable } from '@marriott/mi-shop-components';
import { HotelGalleryPhotoViewerComponentEditable } from '@marriott/mi-shop-components';
import { AdobeClientDataLayer } from '@marriott/mi-shop-components';
import { HeroBannerAEM } from '@marriott/mi-shop-components';
import { AEMText } from '@marriott/mi-shop-components';

import {
  CardLayered,
  CardVertical,
  CardHorizontalMini,
  CardCarouselContainer,
  CardHorizontalFeature,
  Footer,
  StaticWrapper,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
} from '@marriott/mi-common-static-components';
import { CardOverview } from '@marriott/mi-cobrand-components';
import { HotelHeaderComponentEditable } from '@marriott/mi-book-components/organisms';
import { SearchFormComponentEditable } from '@marriott/mi-shop-components';
import { TabbedSearchForm } from '@marriott/mi-shop-components';
import { SearchResultsComponentEditable } from '@marriott/mi-shop-components';
import { MerchandisingSmallBanner, MerchandisingFeatureBannerComp } from '@marriott/mi-merch-components';

import { PropertyBarWrapper } from '@marriott/mi-homepage-components';

export const AEM_REACT_MAPPING = {
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgallerytitle`]: HotelGalleryTitleEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelinformation`]: HotelInformationComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/headingcomponent`]: HeadingComponent,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform/v1/searchform`]: SearchFormComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryoverview`]: HotelOverviewComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryphotoviewer`]:
    HotelGalleryPhotoViewerComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/adobeclientdatalayer`]: AdobeClientDataLayer,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/herobanner/v1/herobanner`]: HeroBannerAEM,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/text`]: AEMText,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/availabilitycalendar/v1/availabilitycalendar`]:
    AvailabilityCalendarEditable,
  [`mcom-book-spa/components/prebooking/hotelheader`]: HotelHeaderComponentEditable,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  'mi-aem-cobrand/components/content/cardoverview': CardOverview,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/mapsubregion/v1/mapsubregion`]: MapAndRegionCardEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/exploredestinations/v1/exploredestinations`]:
    ExploreDestinationsEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/baselinesearchform/v1/baselinesearchform`]:
    SearchFormEditable,
  [`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`]: TabbedSearchForm,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/meetingssearchform/v1/meetingssearchform`]:
    MeetingsAndEventsSearchFormEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hvmibanner/v1/hvmibanner`]: HvmiBannerEditable,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/content/serpbanner`]: MerchandisingFeatureBannerComp,
  ['mi-aem-homepage-spa/components/content/universal-footer']: Footer,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults/v1/searchresults`]:
    SearchResultsComponentEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/merchbanner/v1/merchbanner`]: MerchBannerEditable,
  [`mi-aem-homepage-spa/components/content/propertybar`]: PropertyBarWrapper,
};
export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  locale,
  isBulgariDomain,
  NEXT_PUBLIC_BULGARI_URL
) => {
  MapTo(`mi-aem-homepage-spa/components/content/propertybar`)(props => (
    <PropertyBarWrapper {...props} locale={locale} isAuthorMode={isAuthorMode} />
  ));
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgallerytitle`)(
    props => <HotelGalleryTitleEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SmHotelGalleryTitle',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(
    props => <LinkBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LinkBanner',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/merchbanner/v1/merchbanner`)(MerchBannerEditable, {
    emptyLabel: 'MerchBanner',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MerchandesingSmallBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/serpbanner`)(MerchandisingFeatureBannerComp, {
    emptyLabel: 'Feature Banner',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelinformation`)(
    props => <HotelInformationComponentEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'HotelInformationComponent',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
    emptyLabel: 'StaticWrapper',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/headingcomponent`)(HeadingComponent, {
    emptyLabel: 'HeadingComponent',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchform/v1/searchform`)(
    SearchFormComponentEditable,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hvmibanner/v1/hvmibanner`)(HvmiBannerEditable, {
    emptyLabel: 'HvmiBanner',
    isEmpty: false,
  });
  MapTo(`mi-aem-shop-spa/components/content/tabbedsearchformwrapper/v1/tabbedsearchformwrapper`)(
    props => <TabbedSearchForm {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'TabbedSearchForm',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryoverview`)(HotelOverviewComponentEditable, {
    emptyLabel: 'HotelOverviewComponentEditable',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hotelgalleryphotoviewer`)(
    HotelGalleryPhotoViewerComponentEditable,
    {
      emptyLabel: 'HotelGalleryPhotoViewerComponentEditable',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/adobeclientdatalayer`)(AdobeClientDataLayer, {
    emptyLabel: 'AdobeClientDataLayer',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/text`)(AEMText, { emptyLabel: 'Text', isEmpty: false });
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered, {
    emptyLabel: 'CardLayered',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical, {
    emptyLabel: 'CardVertical',
    isEmpty: false,
  });
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini, {
    emptyLabel: 'CardHorizontalMini',
    isEmpty: false,
  });

  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(
    props => <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'CardCarouselContainer',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/availabilitycalendar/v1/availabilitycalendar`)(
    props => <AvailabilityCalendarEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'AvailabilityCalendarComponent',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature, {
    emptyLabel: 'CardHorizontalFeature',
    isEmpty: false,
  });
  MapTo(`mi-aem-cobrand/components/content/cardoverview`)(CardOverview, {
    emptyLabel: 'CardOverview',
    isEmpty: false,
  });
  MapTo(`mcom-book-spa/components/prebooking/hotelheader`)(
    props => (
      <div className={`${props.model.styleclass} m-container-fullbleed`}>
        <HotelHeaderComponentEditable
          {...props}
          isAuthorMode={isAuthorMode}
          acceptLanguage={locale}
          isBulgariDomain={isBulgariDomain}
          NEXT_PUBLIC_BULGARI_URL={NEXT_PUBLIC_BULGARI_URL ?? ''}
        />
      </div>
    ),
    {
      emptyLabel: 'HotelHeaderComponent',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/mapsubregion/v1/mapsubregion`)(
    props => <MapAndRegionCardEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MapAndRegionCardEditable',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/exploredestinations/v1/exploredestinations`)(
    props => <ExploreDestinationsEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ExploreDestinationsComponent',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/baselinesearchform/v1/baselinesearchform`)(
    props => <SearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/meetingssearchform/v1/meetingssearchform`)(
    props => <MeetingsAndEventsSearchFormEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MeetingsAndEventsSearchForm',
      isEmpty: false,
    }
  );
  MapTo('mi-aem-homepage-spa/components/content/universal-footer')(Footer, {
    emptyLabel: 'Footer',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'NavigationContainerWrapper',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
    emptyLabel: 'NavigationUtilityLinkWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
    emptyLabel: 'NavigationWrapper',
    isEmpty: false,
  });
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/searchresults/v1/searchresults`)(
    SearchResultsComponentEditable,
    {
      emptyLabel: 'SearchResultsComponent',
      isEmpty: false,
    }
  );
  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      }
    });
  }
};
